export const TelemetryType = {
  LOG: 'log',
  CONFIGURATION: 'configuration',
  USAGE: 'usage'
};
